// extracted by mini-css-extract-plugin
export var gif = "_bv-0";